const labels = {
    nl: {
        about: 'Over mij',
        address: 'Straat & huisnummer',
        address_extra: 'Adress extra',
        birth_country: 'Geboorteland',
        birth_place: 'Geboorteplaats',
        birthday: 'Geboortedatum',
        bravo_number: 'Bravonummer',
        children: 'Kinderen?',
        children_amount: 'Aantal kinderen',
        church_tax: 'Geloofsgemeenschap',
        city: 'Plaats',
        contract_end: 'Datum uit dienst',
        contract_hours: 'Uren per week',
        contract_start: 'Datum in dienst',
        contract_type: 'Contracttype',
        cost_center: 'Kostenplaats',
        cost_center_code: 'Kostenplaats (code)',
        cost_center_name: 'Kostenplaats (naam)',
        country: 'Land',
        education_level: 'Hoogste schooldiploma',
        email: 'Email',
        employee_number: 'Personeelsnummer',
        employee_type: 'Werknemerstype',
        fax: 'Fax',
        fname: 'Voornaam',
        gender: 'Geslacht',
        health_insurance_last: 'Laatste wettelijke ziektekostenverzekering',
        health_insurance_last_unknown: 'onbekend / niet verzekerd',
        health_insurance_law: 'Ziektekostenverzekering',
        health_insurance_private: 'Ziektekostenverzekering',
        health_insurance_proof: 'Bewijs van ziektekostenverzekering',
        health_insurance_type: 'Type verzekering',
        iban: 'IBAN',
        job_title: 'Functieomschrijving',
        lname: 'Achternaam',
        lname_maiden: 'Meisjesnaam',
        marital_status: 'Getrouwd?',
        mobile: 'Mobiel',
        nationality: 'Nationaliteit',
        pass_number: 'Pasnummer',
        payee: 'Begunstigde',
        payroll: 'Payroll',
        phone: 'Telefoon',
        profession_level: 'Hoogste beroepskwalificatie',
        residence_permit_expiration: 'Verblijfsvergunning tot',
        residence_permit_issued: 'Verblijfsvergunning uitgegeven op',
        residence_permit_issuer: 'Verblijfsvergunning uitgegeven door',
        residence_permit_proof: 'Verblijfsvergunning',
        ssn: 'Burgerservicenummer',
        student_proof: 'Bewijs van inschrijving',
        tax_class: 'Tariefgroep',
        tax_number: 'Fiscaal identificatienummer',
        title: 'Titel',
        work_permit_expiration: 'Werkvergunning tot',
        work_permit_issued: 'Werkvergunning uitgegeven op',
        work_permit_issuer: 'Werkvergunning uitgegeven door',
        work_permit_proof: 'Werkvergunning',
        zip: 'Postcode',
    },
    en: {
        about: 'About me',
        address: 'Street & house number',
        address_extra: 'c/o',
        birth_country: 'Country of birth',
        birth_place: 'Place of birth',
        birthday: 'Date of birth',
        bravo_number: 'Bravo number',
        children: 'Children?',
        children_amount: 'Number of exemptions for children',
        church_tax: 'Employee church tax',
        city: 'City',
        contract_end: 'End date',
        contract_hours: 'Hours per week',
        contract_start: 'Hire date',
        contract_type: 'Contract type',
        cost_center: 'Cost center',
        cost_center_code: 'Cost center (code)',
        cost_center_name: 'Cost center (name)',
        country: 'Country',
        education_level: 'Highest education level',
        email: 'E-mail',
        employee_number: 'Employee number',
        employee_type: 'Employee type',
        fax: 'Fax',
        fname: 'First name',
        gender: 'Gender',
        health_insurance_last: 'Last insurance provider by law',
        health_insurance_last_unknown: 'unknown / not insured',
        health_insurance_law: 'Health insurance provider',
        health_insurance_private: 'Health insurance provider',
        health_insurance_proof: 'Proof of insurance',
        health_insurance_type: 'Insurance type',
        iban: 'IBAN',
        job_title: 'Job title',
        lname: 'Last name',
        lname_maiden: 'Maiden name',
        marital_status: 'Married?',
        mobile: 'Mobile',
        nationality: 'Nationality',
        pass_number: 'Pass number',
        payee: 'Payee',
        payroll: 'Payroll',
        phone: 'Phone',
        profession_level: 'Highest professional qualification',
        residence_permit_expiration: 'Residence permit until',
        residence_permit_issued: 'Residence permit issued on',
        residence_permit_issuer: 'Residence permit issued by',
        residence_permit_proof: 'Residence permit',
        ssn: 'Social security number',
        student_proof: 'Proof of study',
        tax_class: 'Tax class',
        tax_number: 'Tax number',
        title: 'Title',
        work_permit_expiration: 'Work permit until',
        work_permit_issued: 'Work permit issued on',
        work_permit_issuer: 'Work permit issued by',
        work_permit_proof: 'Work permit',
        zip: 'Zip code',
    },
    de: {
        about: 'Über mich',
        address: 'Straße und Hausnummer',
        address_extra: 'Anschriftenzusatz',
        birth_country: 'Geburtsland',
        birth_place: 'Geburtsort',
        birthday: 'Geburtsdatum',
        bravo_number: 'Bravo Nummer',
        children: 'Kinder?',
        children_amount: 'Anzahl der Kinder',
        church_tax: 'Konfessions&shy;zugehörigkeit',
        city: 'Ort',
        contract_end: 'Austrittsdatum',
        contract_hours: 'Wöchentliche Arbeitszeit',
        contract_start: 'Eintrittsdatum',
        contract_type: 'Arbeitsverhältnis',
        cost_center: 'Kostenstelle',
        cost_center_code: 'Kostenstelle (Code)',
        cost_center_name: 'Kostenstelle (Bezeichnung)',
        country: 'Land',
        education_level: 'Höchster Schulabschluss',
        email: 'E-mail',
        employee_number: 'Personalnummer',
        employee_type: 'Arbeitnehmertyp',
        fax: 'Fax',
        fname: 'Vorname',
        gender: 'Geschlecht',
        health_insurance_last: 'Letzte gesetzliche Krankenkasse',
        health_insurance_last_unknown: 'unbekannt / unversichert',
        health_insurance_law: 'Gesetzliche Krankenkasse',
        health_insurance_private: 'Private Krankenkasse',
        health_insurance_proof: 'Beitragsbescheinigung',
        health_insurance_type: 'Versicherungsklasse',
        iban: 'IBAN',
        job_title: 'Beschäftigungstyp',
        lname: 'Nachname',
        lname_maiden: 'Geburtsname',
        marital_status: 'Verheiratet?',
        mobile: 'Mobil',
        nationality: 'Nationalität',
        pass_number: 'Pass Nummer',
        payee: 'Kontoinhaber',
        payroll: 'Payroll',
        phone: 'Telefon',
        profession_level: 'Höchster beruflicher Ausbildungsabschluss',
        residence_permit_expiration: 'Aufenthaltserlaubnis bis',
        residence_permit_issued: 'Aufenthaltserlaubnis erteilt am',
        residence_permit_issuer: 'Aufenthaltserlaubnis erteilt durch',
        residence_permit_proof: 'Aufenthaltserlaubnis',
        ssn: 'Sozialversicherungs&shy;nummer',
        student_proof: 'Studentenbescheinigung',
        tax_class: 'Steuerklasse',
        tax_number: 'Steuer Identifikations&shy;nummer',
        title: 'Akademischer Grad',
        work_permit_expiration: 'Arbeitserlaubnis bis',
        work_permit_issued: 'Arbeitserlaubnis erteilt am',
        work_permit_issuer: 'Arbeitserlaubnis erteilt durch',
        work_permit_proof: 'Arbeitserlaubnis',
        zip: 'Postleitzahl',
    },
    pl: {
        about: 'About me',
        address: 'Ulica i numer domu',
        address_extra: 'Dodatek adresowy',
        birth_country: 'Kraj urodzenia',
        birth_place: 'Miejsce urodzenia',
        birthday: 'Data urodzenia',
        bravo_number: 'Bravo number',
        children: 'Czy masz dzieci?',
        children_amount: 'Liczba dzieci',
        church_tax: 'Employee church tax',
        city: 'Lokalizacja',
        contract_end: 'End date',
        contract_hours: 'Godziny pracy',
        contract_start: 'Hire date',
        contract_type: 'Typ kontraktu',
        cost_center: 'Centrum kosztów',
        cost_center_code: 'Centrum kosztów (kod)',
        cost_center_name: 'Centrum kosztów (nazwa)',
        country: 'Kraj',
        education_level: 'Highest education level',
        email: 'E-mail',
        employee_number: 'Numer personelu',
        employee_type: 'Typ pracownika',
        fax: 'Fax',
        fname: 'Imię',
        gender: 'Płeć',
        health_insurance_last: 'Ostatnia ustawowa kasa chorych',
        health_insurance_last_unknown: 'onbekend / niet verzekerd',
        health_insurance_law: 'Ustawowe ubezpieczenie zdrowotne',
        health_insurance_private: 'Prywatne ubezpieczenie zdrowotne',
        health_insurance_proof: 'Wyciąg ze składek',
        health_insurance_type: 'Klasa ubezpieczenia',
        iban: 'IBAN',
        job_title: 'Stanowisko',
        lname: 'Nazwisko rodowe',
        lname_maiden: 'Nazwisko panieńskie',
        marital_status: 'Żonaty?',
        mobile: 'Numer telefonu komórkowego',
        nationality: 'Narodowość',
        pass_number: 'Pass number',
        payee: 'Właściciel konta',
        payroll: 'Payroll',
        phone: 'Numer telefonu komórkowego',
        profession_level: 'Highest professional qualification',
        residence_permit_expiration: 'Zezwolenie na pobyt udzielone do',
        residence_permit_issued: 'Zezwolenie na pobyt wydane dnia',
        residence_permit_issuer: 'Zezwolenie na pobyt wydane przez',
        residence_permit_proof: 'Zezwolenie na pobyt',
        ssn: 'Numer ubezpieczenia społecznego',
        student_proof: 'Czy masz ważne świadectwo ukończenia studiów (matury)?',
        tax_class: 'Klasa podatkowa',
        tax_number: 'Tax number',
        title: 'Title',
        work_permit_expiration: 'Zezwolenie na pracę wydane do',
        work_permit_issued: 'Zezwolenie na pracę wydane dnia',
        work_permit_issuer: 'Zezwolenie na pracę wydane przez',
        work_permit_proof: 'Zezwolenie na pracę',
        zip: 'Kod pocztowy',
    },
};

export default labels;


// WEBPACK FOOTER //
// ./src/js/components/lists/labels.js